import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {GetUnreadMessagesService} from '../Services/GetUnreadMessagesService.js'
class GetUnreadMessagesUseCase extends UseCase {
  #config
  #service

  constructor({config, service}) {
    super()
    this.#config = config
    this.#service = service
  }

  static create({config}) {
    return new GetUnreadMessagesUseCase({
      config,
      service: GetUnreadMessagesService.create({config})
    })
  }

  @tracer({metric: 'GetUnreadMessagesUseCase#execute'})
  @AsyncInlineError()
  async execute() {
    const response = await this.#service.execute()
    return response.toJSON()
  }
}

export const factory = GetUnreadMessagesUseCase.create
